<div ngForm="brandingSettingsForm">
	<div class="form-horizontal">
		<div class="form-group row">
			<label class="control-label col-sm-3" id="ewEnableBranding">{{ 'Event_Edit_BrandingToggle' | translate }}</label>
			<div class="col-sm-9">
				<div class="row">
					<div class="col-sm-6">
						<div class="vb-input-field btn-group" aria-labelledby="ewEnableBranding" vbUiRadioBtnGroup>
							<button type="button" class="btn btn-admin btn-white" name="enableCustomBranding" [(ngModel)]="webcast.enableCustomBranding" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
								{{ 'UI_Enabled' | translate }}
							</button>
							<button type="button" class="btn btn-admin btn-white" name="disableCustomBranding" [(ngModel)]="webcast.enableCustomBranding" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
								{{ 'UI_Disabled' | translate }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div [hidden]="!webcast.enableCustomBranding">
			<div class="form-group row">
				<label class="control-label col-sm-3" id="ewLogoImage">{{ 'Branding_LogoImage' | translate }}</label>
				<div class="col-sm-9">
					<div class="row">
						<div class="col-sm-6">
							<image-selector name="brandingLogoImage" [imageComponentMetadata]="{ showResetButton: true }" [defaultImage]="{ url: ThemeService.brandingSettings.themeSettings.logoUri }" [(ngModel)]="webcast.brandingSettings.logoImage">
							</image-selector>
						</div>
					</div>
				</div>
			</div>
			<div class="form-group row">
				<label class="control-label col-sm-3">{{ 'Branding_HeaderSettings_HeaderBackgroundColor' | translate }}</label>
				<div class="col-sm-9">
					<div class="row">
						<div class="col-sm-6">
							<vb-ui-color-selector [accessibilityLabel]="'Branding_HeaderSettings_HeaderBackgroundColor' | translate" name="ewBrandingHeaderBgColor" [(ngModel)]="webcast.brandingSettings.headerColor" [defaultColor]="brandingDefaults.headerColor">
							</vb-ui-color-selector>
						</div>
					</div>
				</div>
			</div>
			<div class="form-group row">
				<label class="control-label col-sm-3">{{ 'Branding_HeaderSettings_HeaderFontColor' | translate }}</label>
				<div class="col-sm-9">
					<div class="row">
						<div class="col-sm-6">
							<vb-ui-color-selector [accessibilityLabel]="'Branding_HeaderSettings_HeaderFontColor' | translate" name="ewBrandingHeaderFontColor" [(ngModel)]="webcast.brandingSettings.headerFontColor" [defaultColor]="brandingDefaults.headerFontColor">
							</vb-ui-color-selector>
						</div>
					</div>
				</div>
			</div>
			<div class="form-group row">
				<label class="control-label col-sm-3" id="">{{ 'Branding_PrimaryColor' | translate }}</label>
				<div class="col-sm-9">
					<div class="row">
						<div class="col-sm-6">
							<vb-ui-color-selector [accessibilityLabel]="'Branding_PrimaryColor' | translate" name="ewBrandingPrimaryColor" [(ngModel)]="webcast.brandingSettings.primaryColor" [defaultColor]="brandingDefaults.primaryColor">
							</vb-ui-color-selector>
						</div>
					</div>
				</div>
			</div>
			<div class="form-group row">
				<label class="control-label col-sm-3" id="">{{ 'Branding_PrimaryFontColor' | translate }}</label>
				<div class="col-sm-9">
					<div class="row">
						<div class="col-sm-6">
							<vb-ui-color-selector [accessibilityLabel]="'Branding_PrimaryFontColor' | translate" name="ewBrandingPrimaryFontColor" [(ngModel)]="webcast.brandingSettings.primaryFontColor" [defaultColor]="brandingDefaults.primaryFontColor">
							</vb-ui-color-selector>
						</div>
					</div>
				</div>
			</div>
			<div class="form-group row">
				<label class="control-label col-sm-3" id="">{{ 'Branding_AccentColor' | translate }}</label>
				<div class="col-sm-9">
					<div class="row">
						<div class="col-sm-6">
							<vb-ui-color-selector [accessibilityLabel]="'Branding_AccentColor' | translate" name="ewBrandingAccentColor" [(ngModel)]="webcast.brandingSettings.accentColor" [defaultColor]="brandingDefaults.accentColor">
							</vb-ui-color-selector>
						</div>
					</div>
				</div>
			</div>
			<div class="form-group row">
				<label class="control-label col-sm-3" id="">{{ 'Branding_AccentFontColor' | translate }}</label>
				<div class="col-sm-9">
					<div class="row">
						<div class="col-sm-6">
							<vb-ui-color-selector [accessibilityLabel]="'Branding_AccentFontColor' | translate" name="ewBrandingAccentFontColor" [(ngModel)]="webcast.brandingSettings.accentFontColor" [defaultColor]="brandingDefaults.accentFontColor">
							</vb-ui-color-selector>
						</div>
					</div>
				</div>
			</div>
			<div class="form-group row">
				<label class="control-label col-sm-3" for="brandingBannerImage">{{ 'Event_Banner_Image' | translate }}</label>
				<div class="col-sm-9">
					<div class="row">
						<div class="col-sm-6">
							<image-selector id="brandingBannerImage" name="brandingBannerImage" [imageComponentMetadata]="{ showDeleteButton: true }" [(ngModel)]="webcast.brandingSettings.bannerImage">
							</image-selector>
							<div class="help-block">
								{{'RecommendedImageSize_Width_Height_Description' | translate : {
									'0': 1200,
									'1': 435,
									'2': ('RecommendedImageSize_Landscape' | translate)}
								}}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="form-group row">
				<label class="control-label col-sm-3" for="speakerProfiles">{{ 'Event_SpeakerProfiles' | translate }}</label>
				<div class="col-sm-9">
					<div class="row">
						<div class="col-sm-6">
							<edit-speaker-profiles id="speakerProfiles" ngModel name="speakerProfiles" ngDefaultControl [webcast]="webcast">
							</edit-speaker-profiles>
						</div>
					</div>
				</div>
			</div>
			<div class="form-group row">
				<div class="col-sm-9">
					@if(webcast.accessControl === 'Public' && webcast.attendeeJoinMethod === 'Registration') {
						<button type="button" vbBtnPrimary class="me-2" (click)="previewGuestLogin()">
							{{ 'Event_PreviewGuestRegistration' | translate }}
						</button>
					}
					<button type="button" vbBtnPrimary [disabled]="form.invalid" (click)="previewWebcast()">
						{{ 'Branding_PreviewWebcastButtonLabel' | translate }}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
